import { FONT_EXTRA_BOLD } from '../../constants/AppConstants';

// empty group that will automatically center itself
export default class ScreenContainer extends Phaser.Group {
  constructor(game, { background = false, title = false, bgClr } = {}) {
    super(game);

    this.game.scale.onSizeChange.add(this.positionContainer, this);

    if (bgClr) {
      this.setBackgroundColour(bgClr);
    }

    if (background) {
      this.setBackground(background);
    }

    if (title) {
      this.setTitle(title);
    }

    this.positionContainer();
  }

  setBackgroundColour(bgClr) {
    if (!this.bgClr) {
      this.bgClr = this.game.make.graphics();
      this.bgClr.beginFill(bgClr, 1);
      this.bgClr.drawRect(0, 0, this.game.defaultWidth, this.game.defaultHeight);
      this.add(this.bgClr);
    }
  }

  setBackground(background) {
    if (!this.bg) {
      this.bg = this.game.make.image(0, 0);
      this.bg.anchor.set(0.5);
      this.bg.x = this.game.defaultWidth * 0.5;
      this.bg.y = this.game.defaultHeight * 0.5;
      this.addChildAt(this.bg, 0);
    }
    this.bg.loadTexture(background);
  }

  setTitle(value) {
    if (!this.title) {
      const fontStyle = {
        font: '75px ' + FONT_EXTRA_BOLD,
        fill: '#ffffff',
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 960,
      };
      this.title = this.game.make.text(this.game.defaultWidth * 0.5, 50, '', fontStyle);
      this.title.setShadow(0, 4, 'rgba(0,0,0,0.15)', 0);
      this.title.anchor.set(0.5, 0);
      this.add(this.title);
    }
    this.title.text = value;
  }

  positionContainer() {
    this.x = (this.game.width - this.game.defaultWidth) / 2;
    this.y = (this.game.height - this.game.defaultHeight) / 2;
  }

  update() {
    super.update();
  }

  destroy() {
    if (this.bgClr) {
      this.bgClr.destroy();
      this.bgClr = null;
    }
    if (this.bg) {
      this.bg.destroy();
      this.bg = null;
    }
    if (this.title) {
      this.title.destroy();
      this.title = null;
    }

    this.game.scale.onSizeChange.remove(this.positionContainer, this);
    super.destroy(true);
  }
}
